import { NON_CONFORMITY_CATEGORIES } from '@/lib/constants/nonConformities'
import { NON_CONFORMITY_STATUS } from '@/lib/constants/status'

export const NON_CONFORMITY_STATUS_LABELS = {
  [NON_CONFORMITY_STATUS.NOT_STARTED]: 'Not Started',
  [NON_CONFORMITY_STATUS.IN_PROGRESS]: 'In Progress',
  [NON_CONFORMITY_STATUS.DELAYED]: 'Delayed',
  [NON_CONFORMITY_STATUS.COMPLETED]: 'Completed',
}

export const NC_STATUS = {
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  delayed: 'Delayed',
  completed: 'Completed',
}

export const NON_CONFORMITIES_TABLE = {
  CONTROL_CODE: 'Control Code',
  TITLE: 'Non Conformities',
  STATUS: 'Status',
  CATEGORY: 'Category',
  CODE: 'Code',
  ASSOCIATED_CONTROL: 'Associated Control',
  NO_CONTROL: 'No Control',
  AUDIT_TYPE: 'Audit',
  YEAR: 'Year',
}

export const NON_CONFORMITY_CATEGORIES_LABELS = {
  [NON_CONFORMITY_CATEGORIES.MAJOR]: 'Major',
  [NON_CONFORMITY_CATEGORIES.MINOR]: 'Minor',
  [NON_CONFORMITY_CATEGORIES.OBSERVATION]: 'Observation',
  [NON_CONFORMITY_CATEGORIES.OPPORTUNITY]: 'Improvement Opportunity',
}

export const NC_CATEGORIES = {
  MAJOR: 'Major',
  MINOR: 'Minor',
  OBSERVATION: 'Observation',
  OPPORTUNITY: 'Opportunity',
}

export const NC_HEADER = {
  TITLE: 'Non-Conformities',
  SEARCH_PLACEHOLDER: 'Search non-conformities...',
  BULK_UPLOAD: 'Bulk Upload',
  EXPORT: 'Export CSV',
  EXPORT_EMPTY: 'There are no non-conformities to export with the current filters.',
}

export const NC_FILTERS = {
  FILTER_BY_CATEGORY: 'Filter by Category',
  FILTER_BY_STATUS: 'Filter by Status',
  FILTER_BY_CONTROL: 'Filter by Control',
  FILTER_BY_YEAR: 'Filter by Year',
  CATEGORY: 'Category',
  YEAR: 'Year',
  CLEAR_FILTERS: 'Clear filters',
}

export const NC_CREATION_DIALOG = {
  TITLE: 'New Non-Conformity',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  CREATE: 'Create',
}
export const NON_CONFORMITY_MESSAGES = {
  UPDATE_SUCCESS: 'Non-conformity updated successfully',
  UPDATE_ERROR: 'Error updating non-conformity',
  FETCH_ERROR: 'Error fetching non-conformity',
  DELETE_SUCCESS: 'Non-conformity deleted successfully',
  DELETE_ERROR: 'Error deleting non-conformity',
  CREATE_SUCCESS: 'Non-conformity created successfully',
  DELETE_DIALOG: {
    TITLE: 'Delete Non-Conformity',
    QUESTION: 'Are you sure you want to delete this non-conformity?',
  },
}

export const NC_DELETE_DIALOG = {
  TITLE: 'Delete Non-Conformity',
  QUESTION: 'Are you sure you want to delete',
  CONFIRMATION: 'This action cannot be undone.',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
}
export const NON_CONFORMITY_DRAWER = {
  EFFECTIVENESS: 'Effectiveness',
  LONG_TERM_ACTION: 'Long Term Action',
  SHORT_TERM_ACTION: 'Short Term Action',
  ROOT_CAUSE: 'Root Cause',
  EVIDENCE: 'Evidence',
  DESCRIPTION: 'Description',
  NO_DESCRIPTION: 'No description available',
  DESCRIPTION_PLACEHOLDER: 'No description',
  SHORT_TERM_ACTION_PLACEHOLDER: 'Write the short term action...',
  LONG_TERM_ACTION_PLACEHOLDER: 'Write the long term action...',
  ATTRIBUTES: 'Attributes',
  CODE: 'Code',
  YEAR: 'Year',
  CATEGORY: 'Category',
  AUDIT_TYPE: 'Audit Type',
  ASSOCIATED_CONTROL: 'Associated Control',
  ROOT_CAUSE_PLACEHOLDER: 'No root cause identified',
  CORRECTIVE_ACTIONS: 'Corrective Actions',
  SHORT_TERM: 'Short Term',
  LONG_TERM: 'Long Term',
  NO_SHORT_TERM_ACTION: 'No short-term action',
  NO_LONG_TERM_ACTION: 'No long-term action',
  RESPONSIBLE: 'Responsible',
  DATE: 'Date',
  NO_OWNER: 'No owner',
  NO_DATE: 'No date',
  NO_CONTROL: 'No Control',
  RATING: 'Rating',
  NOTES: 'Notes',
  NOTES_PLACEHOLDER: 'Add notes about the effectiveness evaluation...',
  NO_NOTES: 'No notes',
}

export const NON_CONFORMITY_DIALOG = {
  CODE: 'Code',
  CATEGORY: 'Category',
  DESCRIPTION: 'Description',
  ROOT_CAUSE: 'Root Cause',
  CREATE: 'Create Non-Conformity',
  ERROR_MESSAGE: 'Please fill in all required fields',
}

export const NC_TYPE_FILTER = {
  ALL: 'All',
  INTERNAL: 'Internal',
  EXTERNAL: 'External',
}

export const NC_BULK_UPLOAD_DIALOG = {
  TITLE: 'Import Non-Conformities from CSV',
  DESCRIPTION:
    'Upload a CSV file to import non-conformities in bulk. All rows must be valid — any errors will be shown below and nothing will be created until you fix them.',
  UPLOAD_FILE: 'Upload CSV',
  UPLOADING: 'Uploading...',
  CREATING: 'Creating non-conformities...',
  SUCCESS: 'Non-conformities imported successfully',
  CANCEL: 'Cancel',
  VALIDATION_TABLE_ROW: 'Row',
  VALIDATION_TABLE_FIELD: 'Field',
  VALIDATION_TABLE_ERROR: 'Error',
  VALIDATION_TABLE_RECEIVED_VALUE: 'Received value',
  DOWNLOAD_SAMPLE: 'Download sample CSV',
  HEADER_ERROR_TITLE: 'Your CSV header has problems',
  HEADER_ERROR_DESCRIPTION: 'Fix the header row in your file and re-upload. The accepted columns are listed below.',
  ACCEPTED_COLUMNS_REQUIRED: 'Required columns',
  ACCEPTED_COLUMNS_OPTIONAL: 'Optional columns',
  SUMMARY_LINE: '{totalRows} rows checked, {errorCount} errors found. Fix them in your CSV and re-upload.',
  ERROR_UNKNOWN_COLUMN: 'Unknown column: {field}',
  ERROR_MISSING_REQUIRED_COLUMN: 'Required column missing: {field}',
  ERROR_MALFORMED_ROW: 'Malformed row',
  ERROR_REQUIRED: '{field} is required',
  ERROR_DUPLICATE_IN_FILE: 'Duplicate name in this file: "{receivedValue}"',
  ERROR_DUPLICATE_IN_DB: 'A non-conformity with this name already exists: "{receivedValue}"',
  ERROR_INVALID_CATEGORY: 'Invalid category "{receivedValue}". Allowed values: {allowedValues}',
  ERROR_INVALID_STATUS: 'Invalid status "{receivedValue}". Allowed values: {allowedValues}',
  ERROR_INVALID_AUDIT_TYPE: 'Invalid audit type "{receivedValue}". Allowed values: {allowedValues}',
  ERROR_INVALID_INTEGER_RANGE: '{field} must be an integer in the allowed range. Got "{receivedValue}"',
  ERROR_INVALID_LENGTH: '{field} is too long. Got "{receivedValue}"',
  ERROR_INVALID_DATE: 'Invalid date in {field}. Got "{receivedValue}"',
  ERROR_OWNER_NOT_FOUND: 'User not found in this organization: "{receivedValue}"',
  ERROR_CONTROL_NOT_FOUND: 'Control not found in this organization: "{receivedValue}"',
  ERROR_INVALID_EVIDENCE_FORMAT: 'Invalid evidence link. Expected "Label|URL"',
  ERROR_OPERATIONAL_ERROR: 'Unable to create non-conformities right now. Please try again.',
}
